"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Level;
(function (Level) {
    Level["H1"] = "+h1";
    Level["H2"] = "+h2";
    Level["H3"] = "+h3";
    Level["H4"] = "+h4";
})(Level || (Level = {}));
var Heading = function (props) {
    var content = props.content;
    var Tag;
    switch (props.level) {
        case Level.H1:
            Tag = "h1";
            break;
        case Level.H2:
            Tag = "h2";
            break;
        case Level.H3:
            Tag = "h3";
            break;
        case Level.H4:
        default:
            Tag = "h4";
    }
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["c-heading", props.level, props.className], utilityClasses).filter(function (className) { return !!className; });
    return react_1.default.createElement(Tag, { className: classes.join(" ") }, content !== null && content !== void 0 ? content : props.children);
};
exports.Heading = Heading;
exports.Heading.Level = Level;
//# sourceMappingURL=Heading.js.map